
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { UserActionsCell } from './UserActionsCell';
import { getRoleBadgeColor, formatRoleDisplay } from '@/utils/userRoleHelpers';
import { ProfileStatusBadge, ProfileCreationBadge } from '@/components/ui/profile-status-badge';

interface Profile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'superadmin' | 'member';
  created_at: string;
  is_verified: boolean;
  auth_user_id: string | null;
  created_from: 'self_registered' | 'invited';
}

interface UserTableProps {
  users: Profile[];
  onEditUser: (user: Profile) => void;
  onDeleteUser: (user: Profile) => void;
  onImpersonateUser: (user: Profile) => void;
  impersonatingUserId: string | null;
}

export const UserTable = React.memo(({
  users,
  onEditUser,
  onDeleteUser,
  onImpersonateUser,
  impersonatingUserId
}: UserTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Source</TableHead>
          <TableHead>Joined</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell className="font-medium">
              {user.first_name} {user.last_name}
            </TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>
              <Badge className={getRoleBadgeColor(user.role)}>
                {formatRoleDisplay(user.role)}
              </Badge>
            </TableCell>
            <TableCell>
              <ProfileStatusBadge profile={user} />
            </TableCell>
            <TableCell>
              <ProfileCreationBadge profile={user} />
            </TableCell>
            <TableCell>
              {new Date(user.created_at).toLocaleDateString()}
            </TableCell>
            <TableCell>
              <UserActionsCell
                user={user}
                onEdit={onEditUser}
                onDelete={onDeleteUser}
                onImpersonate={onImpersonateUser}
                impersonatingUserId={impersonatingUserId}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
});
